import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/administration/company-details',
)({
  component: () => (
    <div>Hello /_authenticated/administration/company-details!</div>
  ),
})
